/**
 * Post-login `next` allowlist (29-24). The MCP consent screen sends a
 * logged-out user to `/login?next=<mcp authorize url>`; after login we must
 * bounce back to that URL so the connection resumes instead of dumping the
 * user into the app. `next` is attacker-controllable, so it is allowlisted:
 *
 *  - same-origin RELATIVE paths (never "//host" protocol-relative).
 *  - the EXACT MCP authorize endpoint (cross-subdomain, needs a full
 *    navigation — returned as an absolute URL for window.location).
 *
 * Mirrors the server's safeReturnUrl (apps/server/src/lib/safe-return-url.ts)
 * — the Google-OAuth path validates there; this covers email/password + the
 * already-authenticated bounce. Returns null when nothing safe.
 */

const MCP_AUTHORIZE_ORIGIN = "https://mcp.provenleap.com";
const MCP_AUTHORIZE_PATH = "/oauth/authorize";

export function safeNext(raw: string | null | undefined): string | null {
  if (!raw) return null;
  if (raw.startsWith("/") && !raw.startsWith("//") && !raw.startsWith("/\\")) {
    return raw;
  }
  try {
    const u = new URL(raw);
    if (u.origin === MCP_AUTHORIZE_ORIGIN && u.pathname === MCP_AUTHORIZE_PATH) {
      return u.toString();
    }
  } catch {
    // not a URL
  }
  return null;
}

/** True when the safe next target is an absolute (cross-subdomain) URL that
 *  needs a full-page navigation rather than client-side routing. */
export function isExternalNext(next: string): boolean {
  return next.startsWith("http://") || next.startsWith("https://");
}
